











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamTasksHeaderContainer_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamDashHeader_team"
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node ).hash = "b2dcd4e6ca830f5f24ea6bdf91d8b581";

export default node;
